/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreMessage = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.689 5.317L10.082 9.76a2.482 2.482 0 0 1-1.579.563c-.564 0-1.13-.189-1.591-.569l-5.6-4.437A2.472 2.472 0 0 0 1 6.501v7a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-7c0-.43-.119-.829-.311-1.183z"
    />
    <path
      fill="currentColor"
      d="M7.539 8.977c.56.46 1.361.461 1.914.006l5.593-4.432A2.478 2.478 0 0 0 13.5 4h-10c-.586 0-1.119.211-1.546.55l5.585 4.426z"
    />
  </svg>
);

IconCoreMessage.displayName = 'IconCoreMessage';

IconCoreMessage.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreMessage);
IconCoreMessage.displayName = 'IconCoreMessage';
